import { Link } from 'react-router-dom';
import './UnderMaintenance.css';

function IconCog({ className = 'uc-icon-svg' }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" aria-hidden>
      <path
        d="M12 15a3 3 0 100-6 3 3 0 000 6z"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 01-2.83 2.83l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-4 0v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83-2.83l.06-.06a1.65 1.65 0 00.33-1.82 1.65 1.65 0 00-1.51-1H3a2 2 0 010-4h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 012.83-2.83l.06.06A1.65 1.65 0 009 4.6a1.65 1.65 0 001-1.51V3a2 2 0 014 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 2.83l-.06.06a1.65 1.65 0 00-.33 1.82 1.65 1.65 0 001.51 1H21a2 2 0 010 4h-.09a1.65 1.65 0 00-1.51 1z"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function IconTools() {
  return (
    <svg className="uc-icon-svg" viewBox="0 0 24 24" fill="none" aria-hidden>
      <path
        d="M14.7 6.3a1 1 0 000 1.4l1.6 1.6a1 1 0 001.4 0l3.77-3.77a6 6 0 01-7.94 7.94l-6.91 6.91a2.12 2.12 0 01-3-3l6.91-6.91a6 6 0 017.94-7.94l-3.76 3.76z"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function IconCode() {
  return (
    <svg className="uc-icon-svg" viewBox="0 0 24 24" fill="none" aria-hidden>
      <path d="M16 18l6-6-6-6M8 6l-6 6 6 6" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

function IconBolt() {
  return (
    <svg viewBox="0 0 24 24" width="26" height="26" fill="none" aria-hidden>
      <path
        d="M13 2L3 14h8l-1 8 10-12h-8l1-8z"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function IconRocket() {
  return (
    <svg viewBox="0 0 24 24" width="26" height="26" fill="none" aria-hidden>
      <path
        d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 00-2.91-.09zM12 15l-3-3a22 22 0 012-3A22 22 0 0119 13a22 22 0 01-3 2l-3-3z"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M15 12l3-3M9 21l.6-.6M12 12l.4-.4" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" />
    </svg>
  );
}

const PARTICLE_COUNT = 15;

/**
 * @param {{ pageTitle: string }} props
 */
export default function UnderMaintenance({ pageTitle }) {
  const featureCards = [
    { icon: <IconBolt />, text: 'Fast & Efficient', mod: 'uc-card-icon--gold' },
    { icon: <IconRocket />, text: 'Modern Design', mod: 'uc-card-icon--pink' },
    { icon: <IconCog className="uc-card-only-svg" />, text: 'Feature Rich', mod: 'uc-card-icon--cyan' },
  ];

  return (
    <div className="uc-root">
      <div className="uc-bg" aria-hidden="true">
        <div className="uc-orb uc-orb--1" />
        <div className="uc-orb uc-orb--2" />
        <div className="uc-orb uc-orb--3" />
        <div className="uc-grid" />
        <div className="uc-particles">
          {Array.from({ length: PARTICLE_COUNT }, (_, i) => (
            <span key={i} className="uc-particle" />
          ))}
        </div>
      </div>

      <div className="uc-inner">
        <div className="uc-icons" aria-hidden="true">
          <div className="uc-icon-card uc-icon-card--purple">
            <span className="uc-icon-glow" />
            <IconCog className="uc-icon-svg uc-cog-spin" />
          </div>
          <div className="uc-icon-card uc-icon-card--red">
            <span className="uc-icon-glow" />
            <IconTools />
          </div>
          <div className="uc-icon-card uc-icon-card--cyan">
            <span className="uc-icon-glow" />
            <IconCode />
          </div>
        </div>

        <div className="uc-badge">
          <span className="uc-badge-dot">
            <span className="uc-badge-dot-inner" />
            <span className="uc-badge-dot-ping" />
          </span>
          <span className="uc-badge-text">In progress</span>
        </div>

        <h1 className="uc-title">
          We&apos;re building
          <span className="uc-title-accent">something amazing</span>
        </h1>

        <p className="uc-desc">
          The <strong>{pageTitle}</strong> area is currently <strong>under construction</strong>. Our team is
          working to bring you a polished experience—check back soon.
        </p>

        <div className="uc-progress">
          <div className="uc-progress-track">
            <div className="uc-progress-fill" />
          </div>
          <p className="uc-progress-label">75% complete</p>
        </div>

        <div className="uc-cards">
          {featureCards.map(({ icon, text, mod }) => (
            <div key={text} className="uc-card">
              <div className={`uc-card-icon ${mod}`}>{icon}</div>
              <p className="uc-card-text">{text}</p>
            </div>
          ))}
        </div>

        <div className="uc-actions">
          <Link to="/" className="uc-btn uc-btn--primary">
            <span>Go back home</span>
          </Link>
          <button type="button" className="uc-btn uc-btn--ghost" disabled>
            Notify me
          </button>
        </div>

        <div className="uc-dots" aria-hidden="true">
          <span className="uc-dot" />
          <span className="uc-dot" />
          <span className="uc-dot" />
        </div>
      </div>

      <div className="uc-wave" aria-hidden="true">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
          <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" />
        </svg>
      </div>
    </div>
  );
}
